module.exports = __webpack_public_path__ + "img/remove-dep.c9c7bb90.svg";